export default __webpack_public_path__ + "static/media/Poppins-Medium.2d6ae121.ttf";